<div class="modal">
  <div class="modal-overlay" (click)="close()"></div>

  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <span class="modal-title" i18n="@@ProductAddToCartListDialogHeading">Add to a shopping list</span>
        <span class="me-auto"></span>
        <i class="btn btn-danger bi bi-x-lg" (click)="close()"></i>
      </div>

      <div class="modal-body">
        <div class="m-3">
          <div class="form-floating">
            <select class="form-select" [(ngModel)]="shoppingCartTemplate" placeholder=" ">
              @for (template of shoppingCartList; track template) {
                <option [ngValue]="template"><span i18n="@@ProductListAddToCartListOptionPrefix">List </span>{{ template.cartName }}</option>
              }
            </select>
            <label i18n="@@ProductListAddToCartListDialogLabel">Please select a shopping list</label>
          </div>

          <button class="btn btn-sm btn-link p-0 mt-3 mb-1 ms-1" i18n="@@ProductAddToCartListDialogCreateCartButton" data-bs-toggle="collapse" data-bs-target="#newCartCollapse" aria-expanded="false" aria-controls="newCartCollapse">
            Create a new shopping list
          </button>

          <div class="collapse" id="newCartCollapse">
            <form class="d-flex flex-row" (submit)="$event.preventDefault(); newCartCreate(shoppingCartTemplateNewName)">
              <div class="form-floating w-100">
                <input
                  class="form-control form-control-sm"
                  type="text"
                  [(ngModel)]="shoppingCartTemplateNewName"
                  placeholder=" "
                  [ngModelOptions]="{ standalone: true }"
                  required
                  (change)="shoppingCartTemplateNewName = shoppingCartTemplateNewName?.trim()"
                />
                <label i18n="@@ProducListAddToCartListDialogNewCartName">New list name</label>
              </div>
              <button class="btn btn-sm btn-primary p-2" type="submit" i18n="@@ProductAddToCartListDialogCreateSubmitButton">Create</button>
            </form>
          </div>
        </div>
      </div>

      <div class="modal-footer flex-column">
        <button type="button" class="btn btn-secondary btn-pretty fw-bold p-2" data-bs-dismiss="modal" i18n="@@ProductAddToCartListDialogYesButton" (click)="yes()">Add to my shopping list</button>
        <a class="c-pointer" (click)="close()" i18n="@@ProductAddToCartListDialogCloseButton">Cancel</a>
      </div>
    </div>
  </div>
</div>
